import { DoorEnter, Edit, Trash, UserAdd } from 'seagull/icons';
import { associatedCustomersOf, canDeleteContact, hasPortalAccessAtCustomer, isUnassociatedContact } from './ContactsDashboardRow.utils';
export const contactRowActions = (param)=>{
    let { contact, texts, onEdit, onAddToAnotherClient, onDelete, onViewClientPortal } = param;
    const associatedCustomers = associatedCustomersOf(contact);
    return [
        {
            icon: Edit,
            label: texts.actions.edit(),
            onClick: ()=>onEdit(contact),
            bi: {
                name: 'contact_edit'
            }
        },
        ...isUnassociatedContact(contact) ? [] : [
            {
                icon: DoorEnter,
                label: texts.actions.viewClientPortal(),
                onClick: ()=>undefined,
                bi: {
                    name: 'contact_view_client_portal'
                },
                subItems: associatedCustomers.map((customer)=>({
                        label: customer.customerName,
                        onClick: ()=>onViewClientPortal(contact, customer.customerId),
                        bi: {
                            name: 'contact_view_client_portal_client'
                        },
                        disabled: !hasPortalAccessAtCustomer(customer),
                        tooltip: hasPortalAccessAtCustomer(customer) ? undefined : texts.noPortalAccessTooltip()
                    }))
            }
        ],
        {
            icon: UserAdd,
            label: texts.actions.addToAnotherClient(),
            onClick: ()=>onAddToAnotherClient(contact),
            bi: {
                name: 'contact_add_to_another_client'
            }
        },
        ...canDeleteContact(contact) ? [
            {
                icon: Trash,
                label: texts.actions.delete(),
                onClick: ()=>onDelete(contact),
                bi: {
                    name: 'contact_delete'
                },
                destructive: true
            }
        ] : []
    ];
};
